export default __webpack_public_path__ + "static/media/cardspannel.e5b57da1.svg";